module.exports = __webpack_public_path__ + "static/media/exhibition-services-img19.f50616f5.jpg";